import type { InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

/** 输入框（shadcn/ui 风格最小实现）。 */
export function Input({ className, ...rest }: InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      {...rest}
      className={cn(
        'h-10 w-full rounded-md border bg-background px-3 text-sm',
        'placeholder:text-muted-foreground',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'aria-[invalid=true]:border-destructive',
        className,
      )}
    />
  );
}
